import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/settings/todos')({
  beforeLoad: () => {
    throw redirect({ to: '/settings/tasks' });
  },
});
